import { GenericError, IErrorDetails } from '@cian/peperrors/shared';
import { DOMAIN, ESubdomain, EErrorType } from '../../shared/constants/domain';

export class VacanciesFetchError extends GenericError {
  public constructor(configuration: { subdomain: ESubdomain; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      domain: `${DOMAIN}#${configuration.subdomain}`,
      type: EErrorType.VacanciesFetchError,
    });

    // Необходимо из-за особенности реализации наследования в TS. Иначе не будет работать instanceof NotFoundError
    Object.setPrototypeOf(this, VacanciesFetchError.prototype);

    // Данный код не является обязательным, он нужен для того, чтобы не было лишнего слоя в стэктрейсе
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, VacanciesFetchError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
